module.exports = __webpack_public_path__ + "img/retailIOne.c7fb92c1.jpg";